import { IArticleData } from "../../interfaces/common/XArticle.interfaces";

export const DEFAULT_ARTICLE_DATA: IArticleData = {
  id: "#",
  name: "Clean T-shirt",
  category: { name: "Men", id: "men" },
  price: 10000,
  discount: 2000,
  initialRate: 3.5,
  // categories: [
  //   { id: "#", name: "Men" },
  //   { id: "#", name: "No Brand" },
  //   { id: "#", name: "Clothes" },
  // ],
  images: [
    "https://d-themes.com/wordpress/riode/demo-24/wp-content/uploads/sites/29/2020/09/product-7-2-600x675.jpg",
    "https://d-themes.com/wordpress/riode/demo-24/wp-content/uploads/sites/29/2020/09/product-7-1-600x675.jpg",
    "https://firebasestorage.googleapis.com/v0/b/xoraia-prod.appspot.com/o/utils%2Fpexels-j-sarkar-991509.jpg?alt=media&token=a74f60a5-80b9-4258-b12f-11cb64f9cbf8",
    "https://firebasestorage.googleapis.com/v0/b/xoraia-prod.appspot.com/o/utils%2Fpexels-j-sarkar-991511.jpg?alt=media&token=c2b98f75-2616-4544-b8b1-83f13696936d",
    "https://firebasestorage.googleapis.com/v0/b/xoraia-prod.appspot.com/o/utils%2Fpexels-monstera-6311652.jpg?alt=media&token=4164f53e-c0a3-4452-9c84-59b75a6df0ae",
  ],
  description:
    "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio recusandae fuga quasi commodi nesciunt. Sit minima repellendus sapiente nihil magni suscipit? Corrupti quis repudiandae id, maxime rerum laudantium commodi voluptate!",
  qty: 10,
  options: [
    {
      id: "opt-1",
      name: "Tailles",
      type: "CHOICE",
      values: ["XL", "L", "M", "S"],
    },
    {
      id: "couleur",
      name: "Couleurs",
      type: "COLOR",
      values: ["#FF0000", "#F7A36A", "#00FF00", "#FFF000"],
    },
    {
      id: "tissus",
      name: "Tissus",
      type: "SELECT",
      values: ["Coton", "Plastique", "Synthetique"],
    },
  ],
  // price: {
  //   currency: "XOF" as "XOF" | "USD",
  //   oldPrice: 10000,
  //   newPrice: 8000,
  // },
  // review: { count: 10, rate: 1.5 },
  // badge: "Nouveauté",
};
